import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Icon } from 'react-icons-kit';
import { fileText } from 'react-icons-kit/feather/fileText';

import style from "./IssueType.module.css";
import ShimmerLoader from '../../../components/ShimmerLoader';

import API from "../../../ApiConfig"
import { DOCUMENT_PREVIEW, GET_ISSUER_ISSUE_DATA_DETAILS } from '../../../Utils/constant';
import cogoToast from 'cogo-toast-react-17-fix';
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';

import { androidArrowBack } from 'react-icons-kit/ionicons/androidArrowBack';
import ReactPortalModal from '../../../components/ReactPortalModal';
import { formatText } from '../../../Utils/helper';
const IssueDocumentDetails = () => {
    const {issued_uuid}=useParams()
    const [loading, setLoading]=useState(false)
    const [documentDetails, setDocumentDetails]=useState()
    const [pdfLoading, setPDFloading]=useState(null)

    const [loadingText, setLoadingText]=useState("")
    const [preview, setPreview] = useState(null)
    const navigate=useNavigate()
      useEffect(()=>{
        getDocumentDetails()
      },[])
      const getDocumentDetails=()=>{
        setLoading(true)
        API.get(GET_ISSUER_ISSUE_DATA_DETAILS+issued_uuid)
        .then(res=>{
          if(res.data.status==200){
            setLoading(false)
            setDocumentDetails(res.data.data)
          }
          
        })
        .catch(err=>{
          setLoading(false)
          cogoToast.error(err.response.data.detail)

        })
      }
      const getPdf = () => {
        setPDFloading(true)
        API.get(DOCUMENT_PREVIEW +issued_uuid)
          .then(response => {
            setPDFloading(null)
            setPreview(response.data.data.pdf);
          }).catch(err => {
            setPDFloading(null);
            setPreview(null)
            setLoadingText("Error while generating PDF");
          })
      }
      const DocPreview = () => {
        var loading = {
          padding: "1rem",
          height: "10vh",
          width: "-webkit-fill-available",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
        if (!preview) {
          return (<div style={loading}>
            {loadingText}
          </div>)
        }
        else {
          return (
            <embed
              key={preview}
              id="pdf-viewer"
              src={preview + "#toolbar=0"}
              type="application/pdf"
              style={{width:"700px", height:"500px"}}
            />
          )
        }
      }
  return (
    <div style={{width:"100%"}}>
    <SlideUpWrapper>
    <div className={style.documentBox}>
      <div>
        <div className={style.documentHeader}>
          <div>
          <Icon icon={androidArrowBack} size={'1.2rem'} onClick={() => navigate(-1)} style={{ cursor: 'pointer', paddingRight:"7px" }} />
          </div>
          <div>
          <Icon icon={fileText} size={30} />
          </div>
          <div>
            <h2>{documentDetails?.document_name}</h2>
          </div>
          {pdfLoading?
          <ShimmerLoader width='2.3rem' height='2.3rem' mt='.2rem' />:
          <div className='eye-icon' onClick={e => getPdf()} title=" View Document">
               <img alt="" src="/eyeoutline.svg" />
            </div>}
        </div>
        <div style={{margin:"15px 0px"}}>
        <div className="credentials-table">
            <table style={{ border:"1px solid lightgray",borderRadius: "10px" }}>
              <tr className="credentials-header bg-lgray">
              <th className="credentials-th" style={{justifyContent:"start"}}>
                  <div className="credentials-table-text" style={{fontSize:"18px"}}>User Details</div>
                </th>
              </tr>
              {loading ? <>
                <tr className="credentials-tr" >
                  <td className="credentials-td">
                    <div className="credentials-table-text"><ShimmerLoader width='15rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"><ShimmerLoader width='15rem' height='1.5rem' /></div>
                  </td>
                </tr>
                </>
                :
                <>
                <tr className='credentials-tr'>
                  <td className='credentials-td' style={{justifyContent:"start"}}>
                    <div className='credentials-table-text' style={{fontSize:"16px",}}>Document Id</div>
                  </td>
                  <td className='credentials-td' style={{justifyContent:"start"}}>
                    <div className='credentials-table-text' style={{fontSize:"16px"}}>{documentDetails?.issued_uuid}</div>
                  </td>
                </tr>
                <tr className='credentials-tr'>
                  <td className='credentials-td' style={{justifyContent:"start"}}>
                    <div className='credentials-table-text' style={{fontSize:"16px"}}>Company Name</div>
                  </td>
                  <td className='credentials-td' style={{justifyContent:"start"}}>
                    <div className='credentials-table-text' style={{fontSize:"16px"}}>{documentDetails?.issuer_name}</div>
                  </td>
                </tr>
                <tr className='credentials-tr'>
                <td className='credentials-td' style={{justifyContent:"start"}}>
                    <div className='credentials-table-text' style={{fontSize:"16px"}}>Name</div>
                  </td>
                  <td className='credentials-td' style={{justifyContent:"start"}}>
                    <div className='credentials-table-text' style={{fontSize:"16px"}}>{documentDetails?.candidate_name}</div>
                  </td>
                </tr>
                </>
                }
              </table>
        </div>

        </div>
        <div>
        <div className="credentials-table">
            <table style={{ border:"1px solid lightgray",borderRadius: "10px" }}>
              <tr className="credentials-header bg-lgray">
              <th className="credentials-th" style={{justifyContent:"start"}}>
                  <div className="credentials-table-text" style={{fontSize:"18px"}}>Issued document fields</div>
                </th>
              </tr>
              {loading ? <>
                <tr className="credentials-tr" >
                  <td className="credentials-td">
                    <div className="credentials-table-text"><ShimmerLoader width='15rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"><ShimmerLoader width='15rem' height='1.5rem' /></div>
                  </td>
                </tr>
                </>
                :
                <>
                {documentDetails?.doc_data && Object.entries(documentDetails?.doc_data).map(([key, value])=>(
                <tr className='credentials-tr'>
                  <td className='credentials-td' style={{justifyContent:"start"}}>
                    <div className='credentials-table-text' style={{fontSize:"16px"}}>{formatText(key)}</div>
                  </td>
                  <td className='credentials-td' style={{justifyContent:"start"}}>
                    <div className='credentials-table-text' style={{fontSize:"16px"}}>{value}</div>
                  </td>
                </tr>))}
                </>
                }
              </table>
        </div>

        </div>
      </div>
       <ReactPortalModal title="Published Document" isOpen={preview} onClose={e => setPreview(null)}>
                <DocPreview />
              </ReactPortalModal>
    </div>
    </SlideUpWrapper>
    </div>
  )
}

export default IssueDocumentDetails;